import { render } from "./Disabled.vue?vue&type=template&id=855475e8"
import script from "./Disabled.vue?vue&type=script&lang=ts"
export * from "./Disabled.vue?vue&type=script&lang=ts"
script.render = render

export default script